export const getSelectedReferenceTab = (state) => {
  return state.references.selectedReferenceTab;
};
